import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-webhook-form', {
  mixins: [eventListenerMixin],

  properties: {
  },

  connected() {
    this.listenTo(this.querySelector('.actions-groups'), {
      'tr-checkbox-field:change': this.handleCheckboxChange.bind(this),
    });
  },

  disconnected() {
    this.stopListening();
  },

  handleCheckboxChange(event) {
    console.log(event);
    const groupCheckbox = closest(event.target, '.group-checkbox');
    if (groupCheckbox) {
      this.toggleEventActions(groupCheckbox.nextElementSibling, event.detail.checked);
      return;
    }

    this.selectGroupCheckbox(closest(event.target, '.actions'));
  },

  toggleEventActions(actionsWrapper, checked) {
    [...actionsWrapper.querySelectorAll('tr-checkbox-field')].forEach((checkbox) => {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = checked;
    });
  },

  selectGroupCheckbox(actionsWrapper) {
    const groupCheckbox = actionsWrapper.previousElementSibling;
    const checkboxes = [...actionsWrapper.querySelectorAll('tr-checkbox-field')];

    if (checkboxes.filter(cb => cb.checked).length === 0) {
      groupCheckbox.checked = false;
      groupCheckbox.indeterminate = false;
    } else if (checkboxes.filter(cb => !cb.checked).length === 0) {
      groupCheckbox.checked = true;
      groupCheckbox.indeterminate = false;
    } else {
      groupCheckbox.checked = false;
      groupCheckbox.indeterminate = true;
    }
  },
});
